module.exports = __webpack_public_path__ + "media/images/icons/share-boxed-4fba08c76914d53c7fd495b66b428488.svg";